import Map from './lib/map';
import Slider from './lib/slider';
import * as IconLibrary from './lib/icons';
import Ui from './lib/ui';
import './css/index.css';
import { components, lazyLoad } from './components';
const custom = require( './custom' );

if ( custom && custom.componentsFilter ) {
	custom.componentsFilter( components, lazyLoad );
}

Object.keys( components ).forEach(k => {
	window.customElements.define(
		k,
		class extends HTMLElement {
			connectedCallback() {
				const s = k.split( '-' );
				let name = '';
				for ( let i = 0; i < s.length; i++ ) {
					if ( i == 0 ) {
						name += s[ i ];
					} else {
						name += s[ i ].charAt(0).toUpperCase() + s[ i ].slice(1);
					}
				}
				components[ k ]( this ).then( c => {
					c[ name ]( this );
				} )
			}
		}
	);
} );

window.swt = {
	map: Map,
	slider: Slider,
	icons: IconLibrary,
	ui: Ui,
};
